var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.21191 3.41166C1.21191 10.113 6.64442 15.5455 13.3458 15.5455C13.6481 15.5455 13.9478 15.5345 14.2447 15.5127C14.5853 15.4877 14.7555 15.4753 14.9106 15.386C15.039 15.3121 15.1607 15.1811 15.2251 15.0476C15.3028 14.8865 15.3028 14.6986 15.3028 14.3227V12.1173C15.3028 11.8012 15.3028 11.6431 15.2508 11.5077C15.2049 11.388 15.1302 11.2814 15.0334 11.1974C14.9239 11.1022 14.7754 11.0481 14.4783 10.9401L11.968 10.0273C11.6224 9.90162 11.4495 9.83876 11.2856 9.8494C11.141 9.8588 11.0019 9.90819 10.8837 9.99196C10.7497 10.0869 10.6551 10.2446 10.4659 10.56L9.82302 11.6314C7.74861 10.6919 6.06694 9.00802 5.12605 6.93439L6.19746 6.29154C6.5128 6.10234 6.67047 6.00774 6.76545 5.8737C6.84922 5.75551 6.89861 5.61639 6.90801 5.47183C6.91865 5.30788 6.85579 5.13508 6.73015 4.78948L5.81728 2.27907C5.70926 1.98203 5.65525 1.8335 5.56007 1.72396C5.47599 1.6272 5.36943 1.55256 5.24976 1.50661C5.11428 1.45459 4.95624 1.45459 4.64017 1.45459H2.4347C2.05884 1.45459 1.87091 1.45459 1.70978 1.53229C1.57632 1.59664 1.44531 1.71841 1.37138 1.84681C1.28212 2.00184 1.26965 2.17215 1.24471 2.51276C1.22298 2.80956 1.21191 3.10932 1.21191 3.41166Z",
    stroke: "black",
    strokeWidth: 2.22222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTel);
export default __webpack_public_path__ + "static/media/tel.4fc0bb6e76d4b00188a3301ea15ea7f6.svg";
export { ForwardRef as ReactComponent };